import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {TranslateModule} from '@ngx-translate/core';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {SopiScrollModule} from '../../../../sopi/components/sopi-scroll/sopi-scroll.module';
import {FormsModule} from '@angular/forms';
import {SopiComponentsModule} from '../../../shared/sopi-components/sopi-components.module';
import {MitteilungenPage} from './mitteilungen.page';
import {MitteilungenPageRoutingModule} from './mitteilungen-routing.module';
import {reducers} from './mitteilungen.reducer';
import {MitteilungenPageUiEffects} from './mitteilungen.effects.ui';
import {MitteilungenPageWsEffects} from './mitteilungen.effects.ws';
import {VeranstaltungenMitteilungenGesendetGruppiertEffects, VeranstaltungenMitteilungenGruppiertEffects, VeranstaltungenMitteilungSenden2Effects, VeranstaltungenVeranstaltungBerechtigungEffects, VeranstaltungenVeranstaltungFunktionsbereicheEffects, VeranstaltungenVeranstaltungMitteilungBerechtigungEffects, VeranstaltungenVeranstaltungMitteilungsVorlagenEffects} from '../../../../client-ngrx/veranstaltungen';
import {KommunikationMitteilungLoeschenEffects} from '../../../../client-ngrx/kommunikation';
import {PipesSharedModule} from '../../../shared/pipes/pipes-shared.module';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule,
        MitteilungenPageRoutingModule,
        StoreModule.forFeature('MitteilungenPage', reducers),
        EffectsModule.forFeature([
            MitteilungenPageUiEffects,
            MitteilungenPageWsEffects,

            VeranstaltungenMitteilungenGesendetGruppiertEffects,
            VeranstaltungenMitteilungenGruppiertEffects,
            VeranstaltungenMitteilungSenden2Effects,
            KommunikationMitteilungLoeschenEffects,
            VeranstaltungenVeranstaltungMitteilungBerechtigungEffects,
            VeranstaltungenVeranstaltungFunktionsbereicheEffects,
            VeranstaltungenVeranstaltungBerechtigungEffects,
            VeranstaltungenVeranstaltungMitteilungsVorlagenEffects
        ]),
        SopiScrollModule,
        FormsModule,
        SopiComponentsModule,
        PipesSharedModule,
    ],
    declarations: [MitteilungenPage],
    entryComponents: [MitteilungenPage],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MitteilungenPageModule {
}
